import { render, staticRenderFns } from "./pointGoodsBuyLog.vue?vue&type=template&id=4265b138&scoped=true&"
import script from "./pointGoodsBuyLog.vue?vue&type=script&lang=js&"
export * from "./pointGoodsBuyLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4265b138",
  null
  
)

export default component.exports